import TargetTrackerActions from "../../prat_actions/targetTracker/targetTrackerActions";

const TargetTrackerReducer = (
  state = {
    isTargetTrackerYTDBrandLoading: false, targetTrackerYTDBrandHasError: false, targetTrackerYTDBrand: [],
    isTargetTrackerTotalSpentLoading: false, targetTrackerTotalSpentHasError: false,
    isTTFileDownloading: false, tTFileDownloadingHasError: false,
    isTargetTrackerYTDBrandANPLoading: false, targetTrackerYTDBrandANPHasError: false,
    isTargetTrackerYTDBrandMTFTSLoading: false, targetTrackerYTDBrandMTFTSHasError: false,
    isTargetTrackerDTTSBrandLoading: false, targetTrackerDTTSBrandHasError: false
  },
  action
) => {
  switch (action.type) {
    case TargetTrackerActions.TARGET_TRACKER_YTD_BRAND_REQUEST:
      return {
        ...state,
        isTargetTrackerYTDBrandLoading: true,
        targetTrackerYTDBrand: [],
        targetTrackerYTDBrandHasError: false
      };
    case TargetTrackerActions.TARGET_TRACKER_YTD_BRAND_SUCCESSFUL:
      return {
        ...state,
        isTargetTrackerYTDBrandLoading: false,
        targetTrackerYTDBrand: action.data.data,
        targetTrackerYTDBrandHasError: false
      };
    case TargetTrackerActions.TARGET_TRACKER_YTD_BRAND_FAILED:
      return {
        ...state,
        errorMessage: {},
        isTargetTrackerYTDBrandLoading: false,
        targetTrackerYTDBrand: [],
        targetTrackerYTDBrandHasError: true
      };


    //********* YTD BRAND MTFTS *********
    case TargetTrackerActions.TARGET_TRACKER_YTD_BRAND_MTFTS_REQUEST:
      return {
        ...state,
        isTargetTrackerYTDBrandMTFTSLoading: true,
        targetTrackerYTDBrandMTFTS: [],
        targetTrackerYTDBrandMTFTSHasError: false
      };
    case TargetTrackerActions.TARGET_TRACKER_YTD_BRAND_MTFTS_SUCCESSFUL:
      return {
        ...state,
        isTargetTrackerYTDBrandMTFTSLoading: false,
        targetTrackerYTDBrandMTFTS: action.data.data,
        targetTrackerYTDBrandMTFTSHasError: false
      };
    case TargetTrackerActions.TARGET_TRACKER_YTD_BRAND_MTFTS_FAILED:
      return {
        ...state,
        errorMessage: {},
        isTargetTrackerYTDBrandMTFTSLoading: false,
        targetTrackerYTDBrandMTFTS: [],
        targetTrackerYTDBrandMTFTSHasError: true
      };


    //********* YTD BRAND ANP *********
    case TargetTrackerActions.TARGET_TRACKER_YTD_BRAND_ANP_REQUEST:
      return {
        ...state,
        isTargetTrackerYTDBrandANPLoading: true,
        targetTrackerYTDBrandANP: [],
        targetTrackerYTDBrandANPHasError: false
      };
    case TargetTrackerActions.TARGET_TRACKER_YTD_BRAND_ANP_SUCCESSFUL:
      return {
        ...state,
        isTargetTrackerYTDBrandANPLoading: false,
        targetTrackerYTDBrandANP: action.data.data,
        targetTrackerYTDBrandANPHasError: false
      };
    case TargetTrackerActions.TARGET_TRACKER_YTD_BRAND_ANP_FAILED:
      return {
        ...state,
        errorMessage: {},
        isTargetTrackerYTDBrandANPLoading: false,
        targetTrackerYTDBrandANP: [],
        targetTrackerYTDBrandANPHasError: true
      };


    //********* TOTAL SPENT *********
    case TargetTrackerActions.TARGET_TRACKER_TOTAL_SPENT_REQUEST:
      return {
        ...state,
        isTargetTrackerTotalSpentLoading: true,
        targetTrackerTotalSpent: [],
        targetTrackerTotalSpentHasError: false
      };
    case TargetTrackerActions.TARGET_TRACKER_TOTAL_SPENT_SUCCESSFUL:
      return {
        ...state,
        isTargetTrackerTotalSpentLoading: false,
        targetTrackerTotalSpent: action.data.data,
        targetTrackerTotalSpentHasError: false
      };
    case TargetTrackerActions.TARGET_TRACKER_TOTAL_SPENT_FAILED:
      return {
        ...state,
        errorMessage: {},
        isTargetTrackerTotalSpentLoading: false,
        targetTrackerTotalSpent: [],
        targetTrackerTotalSpentHasError: true
      };


    //********* DOWNLOAD TT XLX *********
    case TargetTrackerActions.DOWNLOAD_TT_XLX_REQUEST:
      return {
        ...state,
        isTTFileDownloading: true,
        tTFileDownloadingHasError: false
      };
    case TargetTrackerActions.DOWNLOAD_TT_XLX_SUCCESSFUL:
      return {
        ...state,
        isTTFileDownloading: false,
        tTFileDownloadingHasError: false
      };
    case TargetTrackerActions.DOWNLOAD_TT_XLX_FAILED:
      return {
        ...state,
        errorMessage: {},
        isTTFileDownloading: false,
        tTFileDownloadingHasError: true
      };


    //********* DTTS BRAND LEVEL *********
    case TargetTrackerActions.DTTS_BRAND_LEVEL_REQUEST:
      return {
        ...state,
        isTargetTrackerDTTSBrandLoading: true,
        targetTrackerDTTSBrand: [],
        targetTrackerDTTSBrandHasError: false
      };
    case TargetTrackerActions.DTTS_BRAND_LEVEL_SUCCESSFUL:
      return {
        ...state,
        isTargetTrackerDTTSBrandLoading: false,
        targetTrackerDTTSBrand: action.data.data,
        targetTrackerDTTSBrandHasError: false
      };
    case TargetTrackerActions.DTTS_BRAND_LEVEL_FAILED:
      return {
        ...state,
        errorMessage: {},
        isTargetTrackerDTTSBrandLoading: false,
        targetTrackerDTTSBrand: [],
        targetTrackerDTTSBrandHasError: true
      };
    default:
      return {
        ...state
      };
  }
};

export default TargetTrackerReducer;
